import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserDetailsService } from './user-details.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  constructor(private userDetails: UserDetailsService) {}

  setHeaders() {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return requestOptions;
  }
}
